import { styled } from '../../../core/theme/styled';
import { Stack } from '../../atoms/Stack/Stack';

const SvgRoot = styled.svg.attrs({
  width: '475px',
  height: '354px',
  viewBox: '0 0 475 354',
  xmlns: 'http://www.w3.org/2000/svg',
  role: 'presentation',
})`
  color: ${({ theme }) => theme.configuration.primaryColor};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
`;

export const ErrorScreenDecoration = () => (
  <SvgRoot>
    <rect opacity="0.05" x="343" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="435" y="314" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="363" y="292" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="47" y="52" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="74" y="26" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" y="6" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="124" width="14" height="14" fill="currentColor" />
    <rect opacity="0.05" x="313" y="300" width="14" height="14" fill="currentColor" />
    <rect opacity="0.05" x="320" y="293" width="14" height="14" fill="currentColor" />
    <rect opacity="0.05" x="131" y="7" width="14" height="14" fill="currentColor" />
    <rect opacity="0.05" x="105" y="307" width="40" height="40" fill="currentColor" />
    <rect opacity="0.05" x="363" y="20" width="105" height="105" fill="currentColor" />
    <rect opacity="0.05" x="381" y="238" width="69" height="69" fill="currentColor" />
    <rect opacity="0.05" x="20" y="222" width="105" height="105" fill="currentColor" />
  </SvgRoot>
);

export const ErrorScreenStack = styled(Stack)`
  position: relative;
  z-index: 1;
`;
